export class Validator {
    init()
    {
        $('input, textarea').keydown(function () {
            var $this = $(this);
            if ($this.val() == '')
            {
                $this.addClass('pt');
                $this.siblings('label').addClass('focus');
            }
        });

        $('input, textarea').focusout(function () {
            $(this).removeClass('pt');
        });

        if( typeof contactFormRules !== 'object' )
        {
            return;
        }

        var $_FORM = $('#contactForm'),
            submitHandler = function(form) {
                if( typeof grecaptcha === 'object' )
                {
                    grecaptcha.execute( $('[data-rekey]').data('rekey'), {action: 'contactForm'} ).then(function(response) {
                        return ajaxCall({g_response: response, g_action: 'contactForm'});
                    });
                }
                else
                {
                    return ajaxCall();
                }

            },
            ajaxCall = function(appendData) {
                return $.ajax({
                            url: $_FORM.attr("action"),
                            method: 'POST',
                            data: ajaxData(appendData),
                            beforeSend: ajaxBeforeSend,
                            success: ajaxSuccess,
                            error: ajaxError
                        });
            },
            ajaxData = function(appendData) {
                var serialized = $_FORM.serialize();

                if( typeof appendData !== 'object' )
                {
                    return serialized;
                }

                $.each(appendData, function(key, value) {
                    serialized += '&' + key + '=' + value;
                });

                return serialized;
            },
            ajaxBeforeSend = function() {
                $_FORM.find('button').prop('disabled', 'disabled');
            },
            ajaxSuccess = function() {
                callFbq();

                $_FORM.find('input, textarea').val('');
                $_FORM.fadeOut(500, function () {
                    $_FORM.replaceWith('<p class="form__message form__message--success">Wiadomość została wysłana. Dziękujemy.</p>').fadeIn(500);
                });
            },
			ajaxError = function (xhr) {
				const data = xhr.responseJSON != undefined ? xhr.responseJSON : null;
				const message = data != null && data.message !== undefined ? data.message : "Wiadomość nie została wysłana. Prosimy spróbować później.";
				
                $_FORM.find('input, textarea').val('');
                $_FORM.fadeOut(500, function ()
                {
                    $_FORM.replaceWith(`<p class="form__message form__message--error">${message}</p>`).fadeIn(500);
                });
            },
            callFbq = function() {
                if( typeof fbq === 'function' )
                {
                    fbq('track', 'Lead');
                }
            };

        $_FORM.validate({
            rules: contactFormRules,
            errorPlacement: function(error, element) {},
            submitHandler: submitHandler
        });
    }
}
